/**
 * Created by Bart Decorte
 * Date: 2019-08-26
 * Time: 13:52
 */
import MatrixBlock from './MatrixBlock';
import EntriesDetail from '../pages/Entries/_partials/EntriesDetail';
import { isDirectChildOfClass } from '../helpers/dom_helper';

const Matrix = (Matrix = class {}) =>
  class extends Matrix {
    constructor(params) {
      super({ ...params, ignoreSelector: '.js-block--deleted' });
      this.$root = params.$root;
      this.dirtyUnloadNotifier = params.dirtyUnloadNotifier;
      this.detailsBusyCount = 0;
      this.level = params.level ? params.level : 0;
      this.nextIndex = this.nextAvailableIndex();
      this.entriesDetails = this.initEntriesDetails();
      this.blocks = this.initMatrixBlocks();
      this.dummy = this.getDummy();

      if (typeof super.bindListeners === typeof undefined) {
        this.bindListeners();
      }
    }

    bindListeners() {
      if (super.bindListeners) {
        super.bindListeners();
      }

      this.$root.on('click', '.js-btn-add-block', (ev) =>
        this.lBtnAddBlockClicked(ev)
      );
    }

    lBtnAddBlockClicked(ev) {
      ev.preventDefault();
      ev.stopPropagation();

      const $btn = $(ev.target);
      if ($btn.is('[disabled]')) {
        return;
      }

      this.addBlock($btn.data('block-type'));

      return false;
    }

    bindEntriesDetailListeners(entriesDetail) {
      entriesDetail.on('busy', () => {
        this.incrementDetailsBusyCount();
      });
      entriesDetail.on('idle', () => {
        this.incrementDetailsBusyCount(false);
      });
    }

    initMatrixBlocks() {
      const blocks = [];
      const $blocks = this.$root
        .find('.js-block')
        .not(MatrixBlock.dummySelector());

      const scope = this;
      for (let i = 0; i < $blocks.length; i++) {
        let $block = $($blocks[i]);

        // ensure the block is a child of this matrix, and not of a nested one
        if (isDirectChildOfClass($block, this.$root, '.js-matrix')) {
          blocks.push(new MatrixBlock({ $root: $($blocks[i]), parent: scope }));
        }
      }

      return blocks;
    }

    getDummy() {
      const $candidates = this.$root.find(MatrixBlock.dummySelector());

      for (let i = 0; i < $candidates.length; i++) {
        let $candidate = $($candidates[i]);
        if (isDirectChildOfClass($candidate, this.$root, '.js-matrix')) {
          return new MatrixBlock({ $root: $candidate });
        }
      }

      return undefined;
    }

    start(ev, ui) {
      for (let i = 0; i < this.entriesDetails.length; i++) {
        this.entriesDetails[i].startSorting();
      }
      $(ui.placeholder).css('height', $(ui.item).outerHeight());
      this.sortFrom = this.elementDragPosition(ui.item);
    }

    stop(ev, ui) {
      for (let i = 0; i < this.entriesDetails.length; i++) {
        this.entriesDetails[i].stopSorting();
      }
      const to = this.elementDragPosition(ui.item);
      this.updateSort();
    }

    updateSort($elt) {
      this.resort();
    }

    initEntriesDetails() {
      const $rootElements = this.$root.find('.js-entries');
      const entriesDetails = [];
      for (let i = 0; i < $rootElements.length; i++) {
        let $rootElement = $($rootElements[i]);

        // Ensure this is the direct matrix parent
        if (isDirectChildOfClass($rootElement, this.$root, '.js-matrix')) {
          if (!$rootElement.parents('.js-dummy').length) {
            const entriesDetail = new EntriesDetail({
              $root: $($rootElements[i]),
              dirtyUnloadNotifier: this.dirtyUnloadNotifier,
              level: this.level,
            });
            this.bindEntriesDetailListeners(entriesDetail);
            entriesDetails.push(entriesDetail);
          }
        }
      }
      return entriesDetails;
    }

    selectedBlockIds() {
      let $checkboxes = $('.js-entry-select:checked');

      $checkboxes = $checkboxes.toArray().filter((checkbox) => {
        return isDirectChildOfClass($(checkbox), this.$root, '.js-matrix');
      });

      return $checkboxes.map((checkbox) =>
        $(checkbox)
          .parents('.js-block')
          .first()
          .data('entry-id')
      );
    }

    hasSelectedBlocks() {
      return this.selectedBlockIds().length > 0;
    }

    blockInstanceForId(id) {
      for (let i = 0; i < this.blocks.length; i++) {
        let block = this.blocks[i];
        if (block.is('[data-entry-id="' + id + '"]')) {
          return block;
        }
      }
      return undefined;
    }

    selectedBlocks() {
      return this.selectedBlockIds().map((id) => this.blockInstanceForId(id));
    }

    callOnSelectedBlocks(func, params = []) {
      const selectedBlocks = this.selectedBlocks();
      for (let i = 0; i < selectedBlocks.length; i++) {
        let block = selectedBlocks[i];
        block[func].apply(block, params);
      }
    }

    addBlock(type, position) {
      const { block, entriesDetail } = this.createBlock(position);
      block.setType(type);

      if (typeof position !== undefined) {
        position =
          typeof position !== undefined ? position - 1 : this.blocks.length - 1; // 0 index
        if (this.isDescendingSort()) {
          position = this.blocks.length - position - 1; // 0 index
        }
        block.setSortValue(position + 1);
      }
      this.bindEntriesDetailListeners(entriesDetail);
      this.blocks.push(block);
      this.entriesDetails.push(entriesDetail);
      this.resort();
      return this;
    }

    createBlock(position) {
      const $root = this.attachBlock(position);
      const parent = this;
      const block = new MatrixBlock({ $root, parent });
      block.setActive();
      const entriesDetail = new EntriesDetail({
        $root: $root.find('.js-entries').first(),
        dirtyUnloadNotifier: this.dirtyUnloadNotifier,
        level: this.level,
      });
      return { block, entriesDetail };
    }

    attachBlock(position) {
      const $root = this.prepareBlock();
      const $wrap = this.$root.find('.js-sort-wrap').first();
      if (typeof position === typeof undefined) {
        $wrap.append($root);
      } else {
        let $blocks = $wrap.find('.js-block:not(.js-block--deleted,.js-dummy)');
        $blocks = $blocks.toArray().filter((block) => {
          return isDirectChildOfClass($(block), $wrap, '.js-sort-wrap');
        });
        $($blocks[position]).before($root);
      }
      return $root;
    }

    prepareBlock() {
      let html = this.dummy.html();

      const regExp = new RegExp(
        `(<[^>]*)__dummy_level_${this.level}__([^>]*>)`,
        'gm'
      );
      while (regExp.test(html)) {
        html = html.replace(regExp, `$1${this.nextIndex}$2`); // prevent replacing __dummy__ occurences
      }
      this.nextIndex++;

      const $root = $(html);
      $root.removeClass('matrix-block-dummy');
      $root.removeClass('js-dummy');
      return $root;
    }

    deleteBlock(block) {
      const blocks = this.blocks;
      let match;
      let i = 0;

      while (typeof match === typeof undefined && i < blocks.length) {
        if (blocks[i] === block) {
          match = i;
        }
        i++;
      }

      if (typeof match !== typeof undefined) {
        blocks[match].setDeleted();
        this.blocks.splice(match, 1);
        this.resort();
      }

      return this;
    }

    resort() {
      const blocks = this.blocks;
      const blockCount = blocks.length;
      for (let i = 0; i < blocks.length; i++) {
        let block = blocks[i];
        let sortValue;
        if (this.isDescendingSort()) {
          sortValue = blockCount - block.position();
        } else {
          sortValue = block.position() + 1;
        }
        block.setSortValue(sortValue);
      }
    }

    nextAvailableIndex() {
      const $blocks = $('[data-entry-new-id]');
      let indices = [];

      for (let i = 0; i < $blocks.length; i++) {
        indices.push(parseInt($($blocks[i]).data('entry-new-id')));
      }

      indices.sort();
      return indices.length ? indices.pop() + 1 : 1;
    }

    isIdle() {
      return this.detailsBusyCount < 1;
    }

    incrementDetailsBusyCount(doIncrement = true) {
      const initialValue = this.detailsBusyCount;
      this.detailsBusyCount += doIncrement ? 1 : -1;

      if (initialValue > 0 && this.detailsBusyCount < 1) {
        this.emit('idle');
      } else if (initialValue < 1 && this.detailsBusyCount > 0) {
        this.emit('busy');
      }
    }
  };

export default Matrix;



// WEBPACK FOOTER //
// ./resources/assets/js/matrix/Matrix.js